<template>
	<div class="widget-card">
		<h2 v-if="widget" class="text-center">{{ widget.dashboardwidgets_title }}</h2>

		<LoadingSpinner v-if="loading" />
		<table v-else class="table table-sm table-bordered">
			<thead>
				<tr>
					<th>{{ $t('cards.widget.col_french_tiers') }}</th>
					<th>{{ $t('cards.widget.col_french_tiers_count') }}</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>{{ $t('cards.widget.french_tiers_label.sans_siret') }}</td>
					<td class="text-center"><a v-if="sans_siret" href="" @click.prevent="openInfo">{{ sans_siret }}</a><span v-else>{{ sans_siret }}</span></td>
				</tr>
				<tr>
					<td>{{ $t('cards.widget.french_tiers_label.sans_rcs') }}</td>
					<td class="text-center"><a v-if="sans_rcs" href="" @click.prevent="openInfo">{{ sans_rcs }}</a><span v-else>{{ sans_rcs }}</span></td>
				</tr>
			</tbody>
		</table>

		<b-modal ref="tiersModal" :title="$t('cards.widget.french_tiers_modal_title')" hide-footer size="lg">
			<p>{{ $t('cards.widget.french_tiers_modal_intro') }}</p>
			<p>
				<router-link :to="{ name: 'tiersListeOnline' }">{{ $t('cards.widget.french_tiers_modal_link') }}</router-link>
			</p>
			<ul class="mb-0">
				<li>{{ $t('cards.widget.french_tiers_modal_filter_sans_siret') }}</li>
				<li>{{ $t('cards.widget.french_tiers_modal_filter_sans_rcs') }}</li>
			</ul>
		</b-modal>
	</div>
</template>

<script type="text/javascript">
import DashboardMixin from '@/mixins/Dashboard.js'

export default {
	name: 'WidgetFrenchTiers',
	mixins: [DashboardMixin],
	props: ['widget'],
	data() {
		return {
			loading: true,
			sans_siret: 0,
			sans_rcs: 0,
		}
	},

	mounted() {
		this.loadData()
	},

	methods: {
		async loadData() {
			this.loading = true
			const res = await this.getFrenchTiersStats()
			this.sans_siret = res['sans_siret']
			this.sans_rcs = res['sans_rcs']
			this.loading = false
		},

		openInfo() {
			this.$refs.tiersModal.show()
		},
	},

	components: {
		LoadingSpinner: () => import('GroomyRoot/components/Logos/LoadingSpinner_35'),
	},
}
</script>
